import moment, { Moment } from 'moment';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import { WORKING_DAYS } from 'src/pages/employee/sub-pages/employee-details/employee-details.constants';

const transformMapDate = (workingDays: any) => {
  const newWorkingDays: any = {};

  Object.entries(workingDays).forEach(([key, value]: any) => {
    if (value) {
      const { to, from } = value;

      newWorkingDays[key] = {
        to: moment(to).format('DD.MM.YYYY hh:mm'),
        from: moment(from).format('DD.MM.YYYY hh:mm'),
      };
    }
  });

  return newWorkingDays;
};

export const compareWorkingHours = (oldWorkingDays: any, newWorkingDays: any) => {
  const oldToCompare = transformMapDate(pick(oldWorkingDays, WORKING_DAYS));
  const newToCompare = transformMapDate(pick(newWorkingDays, WORKING_DAYS));

  return (
    isEqual(oldToCompare, newToCompare) && oldWorkingDays.breakTime === newWorkingDays.breakTime
  );
};

export const checkIfNewRangeIsValid = (range: any, breakTime: number) => {
  if (range) {
    const [from, to] = range;
    const diff = moment(to).diff(from, 'hours', true);

    return diff > breakTime;
  }

  return true;
};

export const modifyWorkingDate = (value: [Moment, Moment]) => ({
  to: moment()
    .set({
      h: moment(value[1]).get('h'),
      m: moment(value[1]).get('m'),
    })
    .milliseconds(0)
    .seconds(0)
    .toDate(),
  from: moment()
    .set({
      h: moment(value[0]).get('h'),
      m: moment(value[0]).get('m'),
    })
    .milliseconds(0)
    .seconds(0)
    .toDate(),
});
